import React, { useState } from "react";
import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import apiFetch from "../../utils/apiFetch";

// Signs the user out, then clears client-side auth state and returns to login.
// Mirrors the legacy navbar logout: hit Devise sign_out, then clean up regardless.
async function handleLogout() {
  try {
    await apiFetch("/users/sign_out", { method: "DELETE" });
  } catch (e) {
    // fall through to client-side cleanup regardless
  }
  try {
    window.localStorage.removeItem("tk");
    window.localStorage.removeItem("current_school_slug");
  } catch (e) {
    // ignore storage errors (private mode, etc.)
  }
  window.location.replace("/login");
}

export default function UserMenu({
  staff,
  setUserSettingsOpen,
  iconColor = "#00000080",
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  if (!staff) return null;

  const fullName = `${staff.first_name ?? ""} ${staff.last_name ?? ""}`.trim();
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleAccountSecurity = () => {
    handleClose();
    setUserSettingsOpen(true);
  };

  return (
    <>
      <IconButton aria-label="Account menu" onClick={handleOpen}>
        <AccountCircleIcon sx={{ color: iconColor }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem disabled sx={{ "&.Mui-disabled": { opacity: 1 } }}>
          <Typography sx={{ fontWeight: 600, color: "#000000" }}>
            {fullName}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem
          role="menuitem"
          aria-label="Update password"
          onClick={handleAccountSecurity}
        >
          Account security
        </MenuItem>
        <MenuItem role="menuitem" aria-label="Logout" onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: "#00000080" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
